import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import AddMfProductActionModalContainer from './AddMfProductActionModalContainer';
import {setMforderAddMfProductModal} from '../../../../store/slice/ManufSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '85%', xs: '90%' },
  height: { lg: '85%', xs: '90%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: .5,
  backgroundColor:'secondary.lighter',
};

export default function AddMfProductActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {addMfProductModalOpen, mforderObj} = useSelector((state)=>state.manufslice.mforderDashboard);

  useEffect(()=>{
  },[addMfProductModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setMforderAddMfProductModal(false));
  }
  return (
    <Modal
       open={addMfProductModalOpen===undefined?false:addMfProductModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  >
              Add Product @ {mforderObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
          <Box height="20px"></Box>
        </Grid>
        <Grid item>
            < AddMfProductActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}